import React, { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import AdminUsers from './AdminUsers';
import AdminMailingList from './AdminMailingList';
import { useTranslation } from '../../hooks/useTranslation';
import 'bootstrap/dist/css/bootstrap.css';

const AdminManagement = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('users');

    return (
        <div className="dashboard-page">
            <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'users')}>
                <Nav variant="tabs" className="mb-3">
                    <Nav.Item>
                        <Nav.Link eventKey="users">
                            {t('pages.adminManagement.adminUsers')}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="mailing-list">
                            {t('pages.adminManagement.adminMailingList')}
                        </Nav.Link>
                    </Nav.Item>
                </Nav>

                <Tab.Content>
                    <Tab.Pane eventKey="users">
                        <AdminUsers />
                    </Tab.Pane>
                    <Tab.Pane eventKey="mailing-list">
                        <AdminMailingList />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};

export default AdminManagement;
